import React from "react";
import { Trans } from "react-i18next";

interface ConfidExplainationProps {
  confidence: number;
  delay_threshold: string;
  i18nKey: string;
}

export default class ConfidExplaination extends React.PureComponent<ConfidExplainationProps> {
  render() {
    return (
      <div className="indic-tooltip">
        <Trans
          i18nKey={this.props.i18nKey}
          values={{ 
            confidence: this.props.confidence,
            delay_threshold: this.props.delay_threshold === '5min' ? '5min00s' : '15min00s'
          }}
        />
      </div>
    );
  }
}
